PegasusTemplate.WebStructureMutatorBaseMixin = Ember.Mixin.create({
  addChildren: function(element, children) {
    var container = this;
    PegasusTemplate.Helpers.scrapeAttributes(element, this, true);
    PegasusTemplate.Helpers.scrapeClassNames(element, this);

    if ( !children ) { return; }

    var c = [].slice.call(children);

    c.forEach( function(childElement, index) {
      container.pushObject(container.childFactory(childElement));
    });
  },

  sourceElement: '',

  didInsertElement: function(){
    this._super();

    if ( PegasusTemplate.blockRegionInstance === this ) {
      Em.run.scheduleOnce('afterRender', this, 'notifyLoaded');
    }
  },

  notifyLoaded: function(){
    this.get('controller').send('templateLoaded');
  },

  outputClassNames: function(classes){
    var result = this.get('classNames') || [];
    result.removeObject('ember-view');
    return result;
  },

  mutateForOut: function(includeWrapper, cookieOnly) {
    var attributes = PegasusTemplate.Helpers.collectAttributes( this, this.get('attributeBindings') ),
      classes = 'class="' + this.outputClassNames().join(' ') + '"',
      tag = this.get('tagName') || 'div',
      html;

    delete attributes.draggable;

    attributes += ' id="'+this.get('elementId')+'"';

    var children = this.map( function(child) {
      return child.mutateForOut(includeWrapper, cookieOnly);
    });

    var message;
    if ( !cookieOnly ) {
      message = children.map(function(item) {
        return item.message;
      });
    }

    var editor_cookie = children.map(function(item) {
      return item.editor_cookie;
    });

    function sanitize(text){
      var SCRIPT_REGEX = /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi;
      while (SCRIPT_REGEX.test(text)) {
        text = text.replace(SCRIPT_REGEX, "");
      }
      return text;
    }

    function assemble(elements, finalize) {
      var openingTag = [
          tag,
          attributes,
          classes
        ].join(' ').replace(/^(<)?/, '<').concat('>'),
        innerHTML = elements.join(''),
        closingTag = '</' + tag + '>';

      html =
        openingTag +
        innerHTML +
        closingTag;

      if( html.length ){
        if( finalize ){
          html = sanitize( html );
        }
      } else {
        return '';
      }

      return html;
    }

    if ( cookieOnly ) {
      return {
        editor_cookie: assemble( editor_cookie, true )
      };
    }

    var assembledMessage = message ? assemble( message, false) : ''; // assume message will sanitized out back

    return {
      message: assembledMessage,
      editor_cookie: assemble( editor_cookie, true )
    };
  },

  viewType: function( element ) {
    var vrElement, props, p, type, data;
    props = [];
    type = {};
    data = element.dataset ? element.dataset : $(element)[0].dataset;
    for( p in data ){
      if( data.hasOwnProperty( p ) ){
        props.pushObject( p );
      }
    }

    vrElement = props.filter(function( prop ){
      return prop.indexOf('vrContent') === 0 || prop.indexOf( 'vrStructure' ) === 0;
    })[0];

    if( !vrElement ){
      type.name = 'StaticView';
      type.kind = 'Static';
    } else if( vrElement.indexOf('vrContent') === 0 ){
      type.name = [vrElement.replace('vrContent', ''), "ShowView"].join('');
      type.kind = 'Content';
    } else if( vrElement.indexOf('vrStructure') === 0 ){
      type.name = [vrElement.replace('vrStructure', ''), "View"].join('');
      type.kind = 'Structure';
    }
    return type;
  },

  childFactory: function(element) {
    function closestRow(){
      for( var view = this.get('parentView'); view; view = view.get('parentView')){
        if( view.get( 'isVrRow' ) ){
          return view;
        }
      }
    }

    function closestColumn(){
      for( var view = this.get('parentView'); view; view = view.get('parentView')){
        if( view.get( 'isMirrorable' ) ){
          return view;
        }
      }
    }

    var childView;
    var viewType = this.viewType(element);
    var row = closestRow.call(this);
    var column = closestColumn.call(this);
    if( viewType.kind === 'Content' || viewType.kind === 'Static' ) {
      childView = PegasusTemplate[viewType.name].create({
        container: this.container
      });
      childView.mutateForIn(element, row, column);
    } else {
      childView = PegasusTemplate[viewType.name].create({
        container: this.container,
        sourceElement: element
      });
    }
    return childView;
  }
});
